<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <delivery-basises
        v-model="innerValue"
        :exclude="exclude"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :search-label="searchLabel"
        :required-color="requiredColor"
        :required="required"
        :only-route="onlyRoute"
        @change="change" />
  </ValidationProvider>
</template>

<script>
  import DeliveryBasises from './DeliveryBasises.vue'

  export default {
    components: {
      DeliveryBasises
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      exclude: {
        type: Array,
        default: () => {
          return []
        }
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      vid: {
        type: String,
        default: null
      },
      searchLabel: {
        type: String,
        default: ''
      },
      onlyRoute: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
      }
    },
    methods: {
      change: function (deliveryBasises) {
        this.$emit('change', deliveryBasises)
      }
    }
  }
</script>
